module.exports = __webpack_public_path__ + "img/sami.f1a5018a.svg";